<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :staticFilters="staticFilters"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      staticFilters: [
        {
          title: "Фильтр по платформе",
          key: "platform_filter",
          default: null,
          items: [
            {
              id: null,
              key: "app_all",
              title: "Все",
            },
            {
              id: "admin",
              key: "app_admin",
              title: "Админ приложение",
            },
            {
              id: "client",
              key: "app_client",
              title: "Детское приложение",
            },
            {
              id: "guardian",
              key: "app_guardian",
              title: "Родительское приложение",
            },
          ],
        },
      ],
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "key",
          label: "key",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "name",
          label: "name",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          col: " col-12 col-md-12",
          key: "group",
          label: "group",
          type: "static_radio",
          items: [
            { id: null, title: "empty" },
            { id: "labes", title: "labes" },
            { id: "placeholders", title: "placeholders" },
            { id: "buttons", title: "buttons" },
            { id: "descriptions", title: "descriptions" },
          ],
        },
        {
          col: " col-12 col-md-12",
          key: "platform",
          label: "platform",
          type: "static_radio",
          items: [
            { id: "admin", title: "admin" },
            { id: "client", title: "client" },
            { id: "guardian", title: "guardian" },
          ],
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_text",
      itemLink: "texts",
      setLink: "texts",
      columns: [
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "translations",
          object: "name",
          title: "name",
          disableLink: true,
          isMultiLang: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "key",
          title: "key",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "platform",
          title: "platform",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "group",
          title: "group",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
